/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { ShareCardColorModel } from '../../../appAuthorized/dataTransformComponents/ColorShareCard';

import './ShareCardSection.scss';
import { Card } from '../../../../bphComponents/bundle';

const ShareCardSectionTitle: React.FC = (props) => {
  return (
    <div className="font-subhead" style={{}}>
      {props.children}
    </div>
  );
};

const ShareCardSectionContent: React.FC = (props) => {
  return (
    <div className="cmp-sharecardsection-content" style={{}}>
      {props.children}
    </div>
  );
};

interface Props {
  shareCardColorModel: ShareCardColorModel;
}

class ShareCardSection extends React.Component<Props, {}> {

  static Title = ShareCardSectionTitle;
  static Content = ShareCardSectionContent;

  render() {
    const { children, shareCardColorModel } = this.props;

    return (
      <Card.CardSection
        hasBottomBorder
        style={{
          padding: '18px 16px 18px 16px',
          backgroundColor: shareCardColorModel.cssColor(0.05),
        }}
      >
        {children}
      </Card.CardSection>
    );
  }
}

export default ShareCardSection;
